import React from "react";
import { Button, Container } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import SearchBox from "../../../Components/Input/SearchBox";
import ItemList from "../../Components/ItemList";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import { getFullName } from "../../../Modules/utils/fullname";
import { getPhoneNumber } from "../../../Modules/utils/phoneno";
import api from "../../../Services/Api/api";
import EditAgent from "./EditAgent";
import NavBar from "../../Components/NavBar";
import PrintAgentReceipt from "../AccountsScreen/PrintAgentReceipt";
import AgentDetails from "./AgentDetails";

const SCREEN_NAME = "AGENTS_SCREEN";

class AgentsScreen extends AppComponent {
  state = {
    visibleModal: null,
    modalData: null,
    triggerReload: 0,
  };

  additionalQueries = {};

  columns = [
    {
      value: "name",
      label: "Name",
      render: ({ item }) => getFullName(item),
    },
    {
      value: "phone",
      label: "Phone",
      render: ({ item }) => getPhoneNumber(item).formated,
    },
    {
      value: "email",
      label: "Email",
    },
    {
      value: "address",
      label: "Address",
      render: ({ item }) => <div className="multiline">{item.address}</div>,
    },
    {
      value: "actions",
      label: "Actions",
      render: ({ item, index }) => (
        <div
          style={{ textAlign: "center" }}
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            size="sm"
            variant="secondary"
            onClick={() =>
              this.setAsyncState({
                visibleModal: "editAgent",
                modalData: { agent: item },
              })
            }
          >
            Edit
          </Button>{" "}
          <Button
            size="sm"
            variant="secondary"
            disabled={!item?._id}
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "agentReceipt",
                modalData: { agent: item, index },
              });
            }}
          >
            Receipt
          </Button>
        </div>
      ),
    },
  ];

  async retriveData(query) {
    const { agents } = await api.get("v1/agent", query);
    return agents;
  }

  async setItems(items) {
    this.props.setScreenState({ agents: items });
  }

  onNewAgent(item) {
    this.setAsyncState({
      visibleModal: null,
      modalData: null,
      triggerReload: Date.now(),
    });
  }

  handleSearchQ(q) {
    if (q) {
      this.additionalQueries = {
        where: {
          $and: [
            {
              $or: [
                {
                  fullName: { $regex: q, $options: "i" },
                },
                {
                  phone: { $regex: q, $options: "i" },
                },
                {
                  email: { $regex: q, $options: "i" },
                },
              ],
            },
          ],
        },
      };
    } else {
      this.additionalQueries = null;
    }
    this.setAsyncState({ triggerReload: Date.now() });
  }

  async onRowClick(...args) {
    console.log(args);
    if (!args[0]?.item?._id) return;
    await this.setAsyncState({
      visibleModal: "agentDetails",
      modalData: { agent: args[0].item },
    });
    console.log(this.state);
  }

  render() {
    const {
      state: { visibleModal, modalData, triggerReload },
    } = this;

    const screen = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">Agents</div>
          </div>
          <div className="right">
            <SearchBox onChange={this.handleSearchQ.bind(this)} />
            <Button
              onClick={() =>
                this.setAsyncState({
                  visibleModal: "editAgent",
                  modalData: null,
                })
              }
            >
              Add New Agent
            </Button>
          </div>
        </div>

        <div>
          <ItemList
            {...{
              defaultQuery: {},
              triggerReload,
              items: this.props.agents,
              table: {
                columns: this.columns,
                onRowClick: this.onRowClick.bind(this),
              },
              retriveData: this.retriveData.bind(this),
              setItems: this.setItems.bind(this),
              additionalQueries: this.additionalQueries,
            }}
          />
        </div>

        <EditAgent
          {...{
            key: `editAgent-${
              visibleModal === "editAgent"
                ? modalData?.agent?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "editAgent",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewAgent(item),
            ...(modalData || {}),
          }}
        />

        <PrintAgentReceipt
          {...{
            key: `agentReceipt-${
              visibleModal === "agentReceipt"
                ? modalData?.agent?._id?.toString() || "null"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "agentReceipt",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            agents: this.props.agents,
            loadMore: () => this.setAsyncState({ triggerLoadMore: Date.now() }),
            multipleAgents: true,
            ...(modalData || {}),
          }}
        />

        <AgentDetails
          {...{
            key: `agentDetails-${
              visibleModal === "agentDetails" && !!modalData?.agent?._id
                ? modalData?.agent?._id
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "agentDetails" && !!modalData?.agent?._id,

            handleClose: () => this.setAsyncState({ visibleModal: null }),
            ...(modalData || {}),
          }}
        />
      </div>
    );

    return (
      <>
        <NavBar activeLink="/agent" />
        <Container className="gainner">{screen}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  agents: state.vState[SCREEN_NAME]?.agents || [],
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentsScreen);
